import { render, staticRenderFns } from "./FormItemTip.vue?vue&type=template&id=03070a5f&scoped=true&"
import script from "./FormItemTip.vue?vue&type=script&lang=js&"
export * from "./FormItemTip.vue?vue&type=script&lang=js&"
import style0 from "./FormItemTip.vue?vue&type=style&index=0&id=03070a5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03070a5f",
  null
  
)

export default component.exports